export const Arthurian = ({
  color = "black",
}: {
  color?: "black" | "white";
}) => {
  const getFillColor = () => {
    if (color === "black") return "fill-[#231F20]";
    if (color === "white") return "fill-[#fff]";
  };

  return (
    <svg
      className={getFillColor()}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
    >
      <g>
        <path
          d="M138.5,118.4c-2.2-5.4-5.3-10.1-9.3-14.2c-4-4-8.8-7.1-14.2-9.3c-1.5-0.6-2.9-1.1-4.4-1.5
		c0.1,0.5,0.1,0.9,0.1,1.4c0,1.6-0.3,3-0.8,4.4c2.4,0.8,4.7,1.8,6.9,3c5.7,3.3,10.1,7.9,13.2,13.7c3.1,5.9,4.6,12.5,4.6,19.8
		c0,7.3-1.6,13.9-4.7,19.8c-3.1,5.9-7.5,10.5-13.2,13.7c-5.7,3.3-12.1,4.9-19.2,4.9c-7.1,0-13.5-1.6-19.1-4.9
		c-5.6-3.3-10-7.8-13.1-13.7c-3.1-5.9-4.7-12.5-4.7-19.9c0-7.3,1.5-13.9,4.6-19.7c3.1-5.9,7.4-10.5,13.1-13.7c2.2-1.3,4.5-2.3,7-3.1
		c-0.5-1.4-0.8-2.9-0.8-4.4c0-0.5,0-1,0.1-1.4c-1.4,0.4-2.8,0.9-4.2,1.4c-5.3,2.1-10.1,5.1-14.2,9.1c-4.1,4-7.3,8.7-9.5,14.2
		c-2.2,5.5-3.4,11.4-3.4,17.7c0,6.3,1.1,12.2,3.4,17.7c2.2,5.5,5.4,10.2,9.5,14.2c4.1,4,8.8,7,14.2,9.1c5.4,2.1,11.1,3.1,17.2,3.1
		c6.2,0,12-1.1,17.4-3.3c5.4-2.2,10.2-5.3,14.2-9.3c4-4,7.2-8.7,9.3-14.2c2.2-5.4,3.3-11.2,3.3-17.5
		C141.7,129.6,140.6,123.8,138.5,118.4z"
        />
      </g>
      <path
        d="M101.8,133.7l-0.7-30.5c3.2-1.4,5.5-4.6,5.5-8.3c0-5-4.1-9.1-9.1-9.1c-5,0-9.1,4.1-9.1,9.1
	c0,3.7,2.2,6.8,5.3,8.2L93,133.7c-6.7,0.4-13.3,1.8-19.3,4.8c-0.7,0.4-1.4,0.8-2,1.2l2.6,4.5c3.7-1.6,9.5-2.2,13.8-2.5l1.1,5.8h1.6
	v22.2c2.1,0.4,4.3,0.6,6.6,0.6c2.5,0,4.9-0.2,7.2-0.7v-22.1h1.6l1.1-5.8c1.7,0.1,3.4,0.3,5,0.5c2.4,0.3,4.8,0.7,7,1.4
	c0.5,0.2,0.9,0.3,1.4,0.5l2.6-4.5C117.4,135.7,109,134.1,101.8,133.7z"
      />
    </svg>
  );
};
